<script>
    import Window from "../components/Window.svelte";

    export let depth;
    export let toFront = ()=>{};
    export let minimise = ()=>{};
    export let active;

    import {contractAddress} from "../stores/contracts";
</script>
<style>
    /*section{*/
    /*    padding:20px;*/
    /*}*/

    /*h2{*/
    /*    padding-left:10px;*/
    /*    !*padding-top:10px;*!*/
    /*}*/
    /*.question{*/
    /*    padding-top:10px;*/
    /*    font-weight:bold;*/
    /*    color:rgba(255,255,255,0.5);*/
    /*}*/
    /*.answer{*/

    /*}*/

    .about {
        max-width: 380px;
        display:flex;
        flex-direction: column;

        text-align: center;
        line-height: 20px;
        justify-content: center;
    }
    
    @media (min-width: 760px) {
        
        section {
            font-size: 18px;
        }

        .about {
            max-width: 480px;
            line-height: 22px;
        }
    }
    
    h2 {
        font-weight: bold;
        padding-bottom: 5px;
    }

    h3 {
        font-weight: bold;
        padding-top:15px;
    }

    .question {
        text-decoration: underline;
    }

    .answer {
        padding-bottom:10px;
    }

    .container {
        display: flex;
        flex-direction: column;
        align-items: center;
        width:100%;
    }

    a {
        font-weight: bold;
    }

    a:hover {
        text-decoration: underline;
    }

</style>


<Window depth={depth} toFront={toFront} name="ABOUT" active={active}  minimise={minimise}>
<!--    <div>{depth}</div>-->
    <div class="container">
        <div class="about">
            <h2>POW NFT DROPS</h2>

            <section>
                <p class="description">
                    POW NFT DROPS is an NFT distribution platform built upon <a href="https://www.pownft.com/">POW NFT'</a>s mining functionality. It is a fully decentralised process, which inherits all of POW NFT's features such as randomness and front-runner resistance.

                </p>

            </section>


            <h3>How it works</h3>
            <section>
                <p class="description">
                    Any ERC721 NFT can be added to POW NFT DROPS. To create a DROP, you specify your NFT to add, and the POW NFT MINTING TRIGGERs that govern a CLAIM.
                </p>

                <p class="description">
                    The contract is free to use except for Gas. Your DROP NFT will be added to the DROPS GALLERY.
                </p>

                <p class="description">
                    When the POW NFT TRIGGER event occurs the successful Miner may claim your DROP from the wallet holding the Atom which matches the TRIGGER conditions.
                </p>


            </section>

            <h3>FAQ:</h3>
            <section>

                <p class="question">Can I put any NFT in POW NFT Drops?</p>
                <p class="answer">POW NFT Drops works with any ERC721-compliant NFT on the Ethereum mainnet. </p>

                <p class="question">Do I need to be the creator of the NFT I'm adding?</p>
                <p class="answer">No, as long as you own the token.</p>

                <p class="question">How much does it cost?</p>
                <p class="answer">POW NFT Drops is free to use, you only have to pay gas fees.</p>

                <p class="question">If I don’t CLAIM a CLAIMABLE DROP what happens?</p>
                <p class="answer">Anyone who mines an Atom matching the TRIGGER conditions may then CLAIM the DROP.</p>


            </section>

            <h3>Tech stuff</h3>
            <section>
                <p class="description">
                    Verified smart contract code is available on Etherscan, smart contract address is <a href="https://etherscan.io/address/{contractAddress.drops}">{contractAddress.drops}</a>.
                </p>

            </section>
        </div>
    </div>



</Window>
